export default [
  {
    path: '/topup/order',
    name: 'topup order list',
    component: () => import('@/views/Topup/TopupOrder.vue'),
    meta: {
      action: 'topup order list',
      resource: 'topup',
      pageTitle: 'Topup Order',
      breadcrumb: [
        {
          text: 'Topup Order',
          active: true,
        },
      ],
    },
  },
  {
    path: '/topup/order/:id',
    name: 'topup order show',

    component: () => import('@/views/Topup/TopupOrderSingle.vue'),
    meta: {
      action: 'topup order list',
      resource: 'topup',
      pageTitle: 'Order Details',
      breadcrumb: [
        {
          text: 'Order Details',
          active: true,
        },
      ],
    },
  },
  {
    path: '/topup/buy-carrier',
    name: 'topup order carrier',
    component: () => import('@/views/Topup/ToupCarriersSell.vue'),
    meta: {
      action:'topup order create',
      resource: 'topup',
      pageTitle: 'Topup',
      breadcrumb: [
        {
          text: 'Topup',
          active: true,
        },
      ],
    },
  },

  {
    path: '/topup/carrier/:code',
    name: 'topup carrier products',
    component: () => import('@/views/Topup/TopupCarrierProducts.vue'),
    meta: {
      action:'topup order create',
      resource: 'topup',
      pageTitle: 'Product List',
      breadcrumb: [
        {
          text: 'Product List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/topup/product',
    name: 'topup product price list',
    component: () => import('@/views/Topup/TopupProductAdminList.vue'),
    meta: {
      resource: 'topup',
      pageTitle: 'Topup Commissons',
      breadcrumb: [
        {
          text: 'Topup Commissons',
          active: true,
        },
      ],
    },
  },
  {
    path: '/topup/product/:id',
    name: 'topup product admin edit',
    component: () => import('@/views/Topup/TopupProductAdminUpdate.vue'),
    meta: {
      resource: 'topup',
      pageTitle: 'Topup Product',
      breadcrumb: [
        {
          text: 'Topup Product',
          active: true,
        },
      ],
    },
  },
  {
    path: '/topup/carrier',
    name: 'topup carrier list',
    component: () => import('@/views/Topup/TopupCarrierAdminList.vue'),
    meta: {
      resource: 'topup',
      pageTitle: 'Topup Carriers',
      breadcrumb: [
        {
          text: 'Topup Carriers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/topup/carrier/:code',
    name: 'topup carrier list',
    component: () => import('@/views/Topup/TopupCarrierAdminList.vue'),
    meta: {
      resource: 'topup',
      pageTitle: 'Topup Carriers',
      breadcrumb: [
        {
          text: 'Topup Carriers',
          active: true,
        },
      ],
    },
  },
  {
    path: '/topup/plan',
    name: 'topup plan list',
    component: () => import('@/views/Topup/Plan/List'),
    meta: {
      pageTitle: 'Topup Plan',
      breadcrumb: [
        {
          text: 'Topup Plan',
          active: true,
        },
      ],
    },
  },

  {
    path: '/topup/plan/:id/update',
    name: 'topup plan update',
    component: () => import('@/views/Topup/Plan/UpsertMerged'),
    meta: {
      pageTitle: 'Topup Plan',
      breadcrumb: [
        {
          text: 'Topup Plan',
          active: true,
        },
      ],
    },
  },

  {
    path: '/topup/plan/create',
    name: 'topup plan create',
    component: () => import('@/views/Topup/Plan/UpsertMerged'),
    meta: {
      pageTitle: 'Topup Plan',
      breadcrumb: [
        {
          text: 'Topup Plan',
          active: true,
        },
      ],
    },
  },
]
